import { render, staticRenderFns } from "./BotManageOld.vue?vue&type=template&id=ec53b514&scoped=true&"
import script from "./BotManageOld.vue?vue&type=script&lang=js&"
export * from "./BotManageOld.vue?vue&type=script&lang=js&"
import style0 from "./BotManageOld.vue?vue&type=style&index=0&id=ec53b514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec53b514",
  null
  
)

export default component.exports